import Style from "./EnterprisesTableStyle";
import Spinner from "../../shared/Spinner/Spinner";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";
import api from "../../services/api";

import { FaTrashAlt, FaPen } from "react-icons/fa";
import { useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle";

export default function EnterprisesTable(props) {
  const [enterprises, setEnterprises] = useState([] as any);
  const [enterprise, setEnterprise] = useState({} as any);

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ success: "", error: "" });
  const [showPopUpDelete, setShowPopUpDelete] = useState(false);

  useEffect(() => {
    setLoading(true);
    LoadEnterprises().then(() => {
      setLoading(false);
    });
  }, []);

  async function LoadEnterprises() {
    try {
      setLoading(true)
      const result = await api.get(`/enterprises/ofCompany`);
      setEnterprises(result.data.enterprises);
      setLoading(false)
    }
    catch (error: any) {
      setMessage({ success: "", error: error?.response?.data?.message })
      setLoading(false)
    }
  }

  async function onDelete() {
    setLoading(true);
    try {
      const result = await api.delete(`/enterprises/${enterprise.id}`);
      if (result.data.success) {
        setMessage({ success: "Empreendimento deletado com sucesso!", error: "" });
        onClosePopUp();
        await LoadEnterprises();
        setLoading(false);
      } else {
        setMessage({ success: "", error: "Problema ao deletar o empreendimento: " + result.data });
        onClosePopUp();
        setLoading(false);
      }
    } catch (error: any) {
      onClosePopUp();
      setLoading(false);
      setMessage({ success: "", error: error?.response?.data?.message })
    }
  }

  function onEnterpriseMenu(enterpriseId) {
    props.history.push(`/enterprises/${enterpriseId}`)
  }


  function onOpenPopUp(enterprise) {
    setEnterprise(enterprise);
    setShowPopUpDelete(true);
  }
  function onClosePopUp() {
    setShowPopUpDelete(false)
  }

  return (
    <Style>
      <PageTitle title="Empreendimentos" />
      <TwoButtonsModal
        show={showPopUpDelete}
        onHide={onClosePopUp}
        loading={loading}
        title="Deleção de empreendimento!"
        body={`Você está tentando deletar o empreendimento "${enterprise.name}", essa ação é irreversível!`}
        secondaryText="Fechar"
        secondaryOnClick={onClosePopUp}
        secondaryDisabled={loading}
        primaryText="Deletar"
        primaryOnClick={onDelete}
        primaryDisabled={loading}
      />

      <Spinner spinning={loading} />
      <section className="table-title">
        <h1>Empreendimentos</h1>
        <button onClick={() => props.history.push("/enterprises/create/")}>Adicionar Empreendimento</button>
      </section>
      {message.error && <p className="alert alert-error">Erro: {message.error}</p>}
      {message.success && <p className="alert alert-info">{message.success}</p>}

      <table className="table table-striped table-bordered table-hover main-table">
        <thead >
          <tr>
            <th>Empreendimento</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {enterprises.length > 0 && enterprises.map(enterprise => {
            return (
              <tr key={enterprise.id}>
                <td className="clickable" onClick={() => onEnterpriseMenu(enterprise.id)}>{enterprise.name}</td>
                <td className="action">
                  <button onClick={() => props.history.push(`/enterprises/edit/${enterprise.id}`)}><FaPen className="icon" /></button>
                  <button onClick={() => onOpenPopUp(enterprise)}><FaTrashAlt className="icon" /></button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Style >

  )
}